import { cn } from '@/lib/utils'
import { Base } from '@/ui/components'
import { memo } from 'react'
import { BaseProps } from '../types'

interface Props extends BaseProps {
  text?: string
}

const Richtext = ({
  className,
  children,
  as = 'div',
  text,
  ...props
}: Props) => {
  if (!text) {
    return null
  }

  return (
    <Base
      as={as}
      dangerouslySetInnerHTML={{ __html: text }}
      className={cn('rich-text', className)}
      {...props}
    >
      {children}
    </Base>
  )
}
Richtext.displayName = 'Richtext'

export default memo(Richtext)
